import {onFind} from "@elements/init-modules-in-scope";
import Modal from 'bootstrap/js/dist/modal';

export function init () {
    if(_config.openModalOnPageload) {
        let modalName = "#" + _config.openModalOnPageload;

        onFind(modalName ,function (modal) {
            if(modal){
                let infoModal = new Modal(modal);


                    infoModal.show();
            }
        });
    }
}